"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { authAPI } from "@/api/api";

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    authAPI
      .me()
      .then((r) => router.replace(r.data.authenticated ? "/lk" : "/auth"))
      .catch(() => router.replace("/auth"));
  }, [router]);

  return null;
}
